import Vue from 'vue'

async function find (params = {}) {
  return Vue.api.get('/user-activities', { params }).then(response => response.data)
}

export default {
  find
}
